var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('page-header',{attrs:{"is-transparent":_vm.currentIsTransparent,"is-no-shadow":_vm.currentIsNoShadow}}),_vm._v(" "),_c('div',{ref:"backTop",staticClass:"main-container"},[_c('transition',{attrs:{"name":"el-fade-in-linear"}},[_c('router-view')],1)],1),_vm._v(" "),_c('apj-tool'),_vm._v(" "),_c('page-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a17c6fd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 